// assets/cards-lightbox.js
(function () {
  // Nur auf Seiten mit dem Grid aktiv werden
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  ready(function(){
    var root = document.querySelector('#graded-root');
    var grid = document.querySelector('.cards-grid');
    if(!root || !grid) return;

    // Counter aktualisieren
    var countEl = document.getElementById('card-count');
    if(countEl) countEl.textContent = grid.querySelectorAll('.card').length;

    // Lightbox-Element (einmal global anhängen)
    var lb = document.getElementById('lightbox');
    if(!lb){
      lb = document.createElement('div');
      lb.id = 'lightbox';
      lb.className = 'lightbox';
      lb.hidden = true;
      lb.innerHTML = '<span class="close">&times;</span><img id="lightbox-img" src="" alt="">';
      document.body.appendChild(lb);

      // Close-Events
      lb.querySelector('.close').addEventListener('click', ()=> lb.hidden = true);
      lb.addEventListener('click', e=>{ if(e.target.id==='lightbox'){ lb.hidden = true; } });
      document.addEventListener('keydown', e=>{ if(e.key === 'Escape') lb.hidden = true; });
    }

    // Event Delegation: Klick irgendwo auf die Card öffnet das Bild
    grid.addEventListener('click', function(e){
      var card = e.target.closest('.card');
      if(!card) return;
      var img = card.querySelector('img');
      if(!img || !img.src) return;
      document.getElementById('lightbox-img').src = img.src;
      lb.hidden = false;
    });
  });
})();
